"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultFields = ['bleed', 'orientation', 'length'];
var valueFields = ['cutCode', 'paper', 'queue', 'size', 'up', 'weight'];
/**
 * @namespace ImpositionsPath
 */

/**
 * this will set the appropriate path to the dependent value, based on whether
 * it is a wrapper-type component or not.
 * @private
 */

function getFieldPath(paperType, designName, productType, field, bleed, orientation, length) {
  if (productType.match(/wrapper/i)) {
    switch (field) {
      case 'cutCode':
      case 'up':
        return [field, bleed, length];

      case 'queue':
        return [field, orientation, bleed, length];

      case 'size':
        return [field, length];

      default:
        return [field];
    }
  } else {
    switch (field) {
      case 'cutCode':
      case 'up':
        return [field, bleed];

      case 'queue':
        return [field, orientation, bleed];

      default:
        return [field];
    }
  }
}
/**
 * if this object is supposed to point to a 'default' (independent) value,
 * this method will set this.path appropriately
 * @private
 */


function setDefaultsPath(paperType, designName, productType, field) {
  return [productType, 'defaults', paperType, designName, field];
}
/**
 * if this object is supposed to point to a 'value' (dependent) value,
 * this method will set this.path appropriately
 * @private
 */


function setValuesPath(paperType, designName, productType, field, bleed, orientation, length) {
  var fieldPath = getFieldPath(paperType, designName, productType, field, bleed, orientation, length);
  return [productType, 'values', paperType].concat(fieldPath);
}
/**
* Pointer to a value in the impositions table
* @property {string} field
* @property {array} path
* @property {string} category ['defaults' | 'values']
*/


var ImpositionPath = function ImpositionPath(paperType, designName, productType, field, bleed, orientation, length) {
  _classCallCheck(this, ImpositionPath);

  var category = '';

  if (defaultFields.includes(field)) {
    category = 'defaults';
  } else if (valueFields.includes(field)) {
    category = 'values';
  } else {
    throw new Error("'field' must be one of ".concat(defaultFields.join('/'), " or ").concat(valueFields.join('/'), ". Got ").concat(field, "."));
  }

  this.field = field;
  this.category = category;

  if (this.category === 'defaults') {
    this.path = setDefaultsPath(paperType, designName, productType, field);
  } else {
    this.path = setValuesPath(paperType, designName, productType, field, bleed, orientation, length);
  }
};
/**
* get the paths to default values (bleed, orientation, length)
* @function
* @memberof ImpositionsPath
* @param {String} paperType - "White Matte", "White Shimmer", etc.
* @param {String} designName - "1940s", "Poppy", etc.
* @param {String} productType - "invitations", "liners", etc.
* @returns {ImpositionPath[]}
*/


function defaults(paperType, designName, productType) {
  var paths = [];
  paths.push(new ImpositionPath(paperType, designName, productType, 'bleed'));
  paths.push(new ImpositionPath(paperType, designName, productType, 'orientation'));

  if (productType.match(/wrapper/i)) {
    paths.push(new ImpositionPath(paperType, designName, productType, 'length'));
  }

  return paths;
}
/**
* get the paths to dependent values (cutCode, weight, paper, etc.)
* @function
* @memberof ImpositionsPath
* @param {String} paperType - "White Matte", "White Shimmer", etc.
* @param {String} designName - "1940s", "Poppy", etc.
* @param {String} productType - "invitations", "liners", etc.
* @param {Object} impositions - (independent values)
* @param {String} impositions.bleed - "b" | "n"
* @param {String} impositions.orientation - "L" | "P"
* @param {String} impositions.length - "l" | "s"
* @returns {ImpositionPath[]}
*/


function values(paperType, designName, productType, impositions) {
  var bleed = impositions.bleed,
      orientation = impositions.orientation,
      length = impositions.length;

  if (!bleed) {
    throw new Error('bleed must be defined');
  }

  if (bleed !== 'n' && bleed !== 'b') {
    throw new Error('bleed must be either b or n');
  }

  if (!orientation) {
    throw new Error('orientation must be defined');
  }

  if (orientation !== 'L' && orientation !== 'P') {
    throw new Error('orientation must be either P or L');
  }

  if (productType.match(/wrapper/i) && !length) {
    throw new Error('If looking for wrapper values, length must be defined.');
  }

  if (length && length !== 'l' && length !== 's') {
    throw new Error('length must be either l or s');
  }

  var locations = valueFields.map(function (field) {
    return new ImpositionPath(paperType, designName, productType, field, bleed, orientation, length);
  });
  return locations;
}

module.exports = {
  defaults: defaults,
  values: values,
  ImpositionPath: ImpositionPath
};